<!--
  ~ Copyright (c) GM Global Technology Operations LLC. All rights reserved.
  ~ This information is confidential and proprietary to GM Global Technology
  ~ Operations LLC and may not be used, modified, copied or distributed.
  -->

<!-- Tab group to hold each Obsolete Records page -->
<mat-tab-group mat-stretch-tabs="false">
  <mat-tab label="Remove Obsolete Market Divisions">
    <ng-template matTabContent>
      <app-remove-obsolete-records *ngIf="obsoleteMarketDivisionsInput"
                                   [obsoleteRecordsInput]="obsoleteMarketDivisionsInput">
      </app-remove-obsolete-records>
    </ng-template>
  </mat-tab>
  <mat-tab label="Remove Obsolete Vehicles">
    <ng-template matTabContent>
      <app-remove-obsolete-records *ngIf="obsoleteVehiclesInput"
                                   [obsoleteRecordsInput]="obsoleteVehiclesInput">
      </app-remove-obsolete-records>
    </ng-template>
  </mat-tab>
  <mat-tab label="Remove Obsolete Engine Configurations">
    <ng-template matTabContent>
      <app-remove-obsolete-records *ngIf="obsoleteEnginesInput"
                                   [obsoleteRecordsInput]="obsoleteEnginesInput">
      </app-remove-obsolete-records>
    </ng-template>
  </mat-tab>
  <mat-tab label="Remove Obsolete Transmission Configurations">
    <ng-template matTabContent>
      <app-remove-obsolete-records *ngIf="obsoleteTransmissionsInput"
                                   [obsoleteRecordsInput]="obsoleteTransmissionsInput">
      </app-remove-obsolete-records>
    </ng-template>
  </mat-tab>
</mat-tab-group>
